import DefaultActivityTypeName from "@mapmycustomers/shared/enum/activity/DefaultActivityTypeName";
import FormLayout, { ChildLayout } from "@mapmycustomers/shared/types/layout/FormLayout";

import { activityLayoutModel } from "../layout/impl";

const getActivityEmailLayouts = (): [FormLayout | undefined, ChildLayout | undefined] => [
  activityLayoutModel.defaultFormLayout,
  activityLayoutModel.defaultFormLayout?.childLayouts?.find(
    ({ crmActivityType }) => crmActivityType?.name === DefaultActivityTypeName.EMAIL
  ),
];

export const getDefaultActivityEmailLayout = (): ChildLayout | FormLayout | undefined => {
  const [layout, emailLayout] = getActivityEmailLayouts();
  return emailLayout ?? layout;
};

export default getActivityEmailLayouts;
